import { Component } from '@angular/core';

@Component({
  selector: 'app-divider',
  template: ` <p-divider class="m-0" /> `,
  host: { class: 'block' },
})
export class DividerComponent {}
